import { Action, ActionType } from "./actionTypes";

const INITIAL_STATE = {
  isConnected: false,
  publicKey: "",
  chainID: "",
  walletType: ""
}

const WalletReducer = (state: object = INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case ActionType.WALLET_CONNECTION:
      return {
        ...state,
        isConnected: action.payload.isConnected,
        publicKey: action.payload.publicKey,
        chainID: action.payload.chainID,
        walletType: action.payload.walletType
      }
    case ActionType.DISCONNECT_WALLET:
      return { ...state }

    default:
      return { ...state }
  }
}

export default WalletReducer;